import { gridMap } from '../mapgrid.ts';
import { withGeometry } from '../mapgeo.ts';
import { make, poly, type MapDoor, type MapPoly, type MapRoof, type Pt } from '../geom.ts';

/**
 * Rail Yard: a grand old railway terminus and freight yard at night, and the night the last train never left. The
 * headhouse (ticket hall, vaulted concourse, waiting rooms, buffet) and Platforms 1 to 4 lie in the north west, and a long
 * express stands at them; the same plan turned half a turn is a goods terminal in the south east. The north east is the
 * freight yard (coal hopper, sidings, signal box, water tower, turntable, engine shed, tunnel mouth, goods office), and
 * its half turn the marshalling yard in the south west. The ASCII is the west half; polygons, doors and roofs follow.
 *
 * r terminus brick, d cast ironwork, f freight boxcar, s stacked sleepers, q kiosk, counter or bench, v coal heap.
 */
const WEST = `
  ............................................................
  ............................................................
  .................................o..........................
  ............................................................
  ......rrrrrrrrrrrrrrrrrrrrrrr...............................
  ......rl...................lr...............................
  ......r.....................r...............................
  ......r..qqqqq..qqqqqq..q...r.rrrrrr...rrrrrrrrrrrrrrrrrrr..
  ......r.....................r.......................l..c....
  ........FFF.................r...............FFFFF...qqqq....
  ........FFF.......................d.......d.FFFFF.d.......d.
  ........FFF.........................FFF.....FFFFF...........
  ...l..r.......qqqq..........r.......FFF.qqq.FFFFF....c......
  ......r.......qqqq..........r.......FFF.....................
  ......r..qqq..........qqq...r...............................
  ......r.....................r.ss............................
  ......r.....................r.ss............................
  ......rrrrrrrrr....rrrrrrrrrr...............................
  ......r.....................r...............qqqqqq..qq......
  ......r.q...................................q........q......
  ...l..r.q.........................d.......d.q........q....d.
  ......r.q...................................qqq..qqqqq......
  ......r....d......m....d..............qqq.......l.......l...
  ......r.....................r...............................
  ............................r...............................
  .........................qq.r...............................
  .........................qq.r...............................
  ......r.....................r...............................
  ......r....d...........d....r.................qqq...........
  ......r.........................l...............l.......l...
  ......r..........A................d.......d.......d.....qqq.
  ......r..cc.........................FFFF.c..............q...
  ......r..c..........................FFFF................q...
  ......r...................q.r...........................qqqq
  ...........d...........d..q.r...............................
  ..........................q.r.ss.....c......................
  .........qq.................r.ss............................
  ......r..qq.................r...............................
  ......r..............FFFFFF.................................
  ......r..............FFFFFF.................................
  ...l..r....d.........FFFFFF.......d.......d.......d.......d.
  ......r..............FFFFFF.................................
  ......r.....................r...............................
  ......rrrr...rrrrrrrr..rrrrrr.......l...............l.......
  ......r.........r...........rrrrr...........................
  ......r.........r........q..rrrrr...........FFFFF...........
  ......r..qqqqq..r........q..rrrrr...........FFFFF...........
  ......r.........r..qq....q..rrrrr...........FFFFF...........
  ......r..FFFFF..r..qq....q..r......................qqqq.....
  .........FFFFF..r.....qq.q..............i.............q.....
  ...l.....FFFFF..r.....qq.q..........rr...rrr..........q..c..
  ......r.........r........q..r.......r......r.......qqqq.....
  ......r..qqqqq..r..qq.......r.......r.......................
  ......r.........r..qq.......r.......r.........b.............
  ......r....g....r.......p...r.......r......r................
  ......r.........r...........r.......rrrrrrrr....i...........
  ..XXX.rrrrrr..rrrrrrr...rrrrr...............................
  ..XXX...rr...............................c..................
  ..XXXX..rr............................................l.....
  ..XXXX..rr..................................................
  ..XXXX..rr...........................FFFFF..................
  ..XXXX..rr.............................FFF..................
  ..XXXX..rr.....b....ss..ffffff..ffffff......................
  ..XXXX..vvvv........ss..ffffff..ffffff......dddd............
  ........vvvv................................dddd.......FFFFF
  ........rr..................................dddd.......FFFFF
  ........rr.............c.........b.......c..dddd.......FFFFF
  ............................................................
  .....rrrrrrrrr..rrrrrrrr....................................
  .....r.................r.l.............o....................
  .....r.................r....................................
  ..p..r.g.......................................b............
  .....r.............................l........................
  .....r.....d.....d..........................................
  .....r.................r...........................e.....l..
  .....r.......b.....m...r....................................
  ...........................................FFF....cl.......l
  ...........................................FFF..............
  .....r.....................................FFF..rrrrrr..rr..
  .....r.................r.c......................r....d......
  .....r.................r.................ffffff.r...........
  ..o..r...a.d.....d.......................ffffff.r......qq...
  .....r..........................................rqqq.....r..
  .....r.......o..................................rrrr..rrrr.c
  .....r.................r....................................
  .....rrrrrrrrrr..rrrrrrr....................................
  .....l.....................b...........c.........g....qq..qq
  ......................................................q.....
  ........rrrr...l.................c....................q.....
  ........rrrr.........................................dqqqqq.
  .................................................l.....l....
  rrrr..rr....................................................
  rr..........................................................
  rr..........................................................
  rr..........................................................
  rr..........................................................
  rrrr..rr....................................................
  ...................l..........qqq..qqq.................l....
  ........rrrr..................q......q.....FFFFF............
  ........rrrr..................q............FFFFF....cc......
  ..........................sss.q............FFFFF............
  ..........................sss.q......q.....FFFFF............
  .........................e....qqqqqqqq......................
  ..........ffffff..ffffff....................................
  ..........ffffff..ffffff....................................
  .FFFF.......................................................
  .FFFF....................................c..................
  .FFFF........m..........o...................................
  .FFFF.....................ffffff..ffffff..ffffffss..........
  .FFFF.....................ffffff..ffffff..ffffffss...d......
  ............................................................
  ...................c.....b.......b.........o.......l.......l
  .................................................rrrrrrrrrrr
  ...................................vvvvvvvvvvv..............
  ...................................vvvvvvvvvvv..............
  .........g.........................vvvvvvvvvvv..............
  ...............FFFFF..................vvvvvvvv..............
  ...............FFFFF.........p........vvvvvvvv.......b.....o
  ...............FFFFF........................................
  ............................................................
`;

/** The express on track 2: five carriages and a steam locomotive, nose east, standing at the buffers since the night the last train never left. */
export const TRAIN = { x: 1600, y: 1300, len: 540, wid: 140, gap: 100, loco: 640, wall: 14 } as const;
const carriageX = (n: number) => TRAIN.x + n * (TRAIN.len + TRAIN.gap);
export const LOCO_X = carriageX(5);

const chamfered = (x: number, y: number, w: number, h: number, c: number): Pt[] => [
  { x: x + c, y }, { x: x + w - c, y }, { x: x + w, y: y + c }, { x: x + w, y: y + h - c }, { x: x + w - c, y: y + h }, { x: x + c, y: y + h }, { x, y: y + h - c }, { x, y: y + c },
];

/** A solid carriage: one chamfered body. Carriage 3 (index 2) is a hollow shell with sliding doors, so it is built from walls. */
function carriage(n: number): MapPoly[] {
  const x = carriageX(n), y = TRAIN.y - TRAIN.wid / 2, { len, wid, wall } = TRAIN;
  const id = `car${n + 1}`;
  const o = { group: id, shape: 'trainCar', height: 40 } as const;
  if (n !== 2) return [make(chamfered(x, y, len, wid, 26), 'carriage', { ...o, id, part: 'body' })];
  // The walk-through carriage: end walls, and side walls with two door openings each, 100 px wide.
  const side = (yy: number, tag: string) => [
    make(poly.rect(x, yy, 80, wall), 'carriage', { ...o, id: `${id}-${tag}0`, part: `side-${tag}` }),
    make(poly.rect(x + 180, yy, 180, wall), 'carriage', { ...o, id: `${id}-${tag}1`, part: `side-${tag}` }),
    make(poly.rect(x + len - 80, yy, 80, wall), 'carriage', { ...o, id: `${id}-${tag}2`, part: `side-${tag}` }),
  ];
  return [
    ...side(y, 'n'), ...side(y + wid - wall, 's'),
    make(poly.rect(x, y + wall, wall, wid - 2 * wall), 'carriage', { ...o, id: `${id}-w`, part: 'end-w' }),
    make(poly.rect(x + len - wall, y + wall, wall, wid - 2 * wall), 'carriage', { ...o, id: `${id}-e`, part: 'end-e' }),
  ];
}

/** A tank locomotive's parts, nose toward +x, centred on (cx, cy): tender, cab, boiler, pilot. */
function locomotive(id: string, cx: number, cy: number): MapPoly[] {
  const o = { group: id, shape: 'locomotive' } as const;
  const at = (pts: readonly (readonly [number, number])[]): Pt[] => pts.map(([px, py]) => ({ x: cx + px, y: cy + py }));
  return [
    make(at([[-320, -68], [-150, -68], [-150, 68], [-320, 68]]), 'locomotive', { ...o, id: `${id}:tender`, part: 'tender', height: 40 }),
    make(at([[-150, -70], [-40, -70], [-40, 70], [-150, 70]]), 'locomotive', { ...o, id: `${id}:cab`, part: 'cab', height: 56 }),
    make(at([[-40, -52], [250, -52], [290, -34], [290, 34], [250, 52], [-40, 52]]), 'locomotive', { ...o, id: `${id}:boiler`, part: 'boiler', height: 42 }),
    make(at([[290, -26], [330, -14], [330, 14], [290, 26]]), 'locomotive', { ...o, id: `${id}:pilot`, part: 'pilot', height: 12, blocksBullets: false, blocksSight: false }),
  ];
}

/** The turntable: a pit rim (two curved walls, open east and west where the tracks run in) round a hub and a girder bridge. */
export const TURNTABLE = { x: 4300, y: 2200, rIn: 250, rOut: 292 } as const;
function turntable(): MapPoly[] {
  const { x, y, rIn, rOut } = TURNTABLE, o = { group: 'turntable', shape: 'turntable' } as const;
  const gap = 0.34;
  return [
    make(poly.arc(x, y, rIn, rOut, gap, Math.PI - gap, 14), 'pitwall', { ...o, id: 'tt-south', part: 'rim-s', height: 22, blocksBullets: false }),
    make(poly.arc(x, y, rIn, rOut, Math.PI + gap, 2 * Math.PI - gap, 14), 'pitwall', { ...o, id: 'tt-north', part: 'rim-n', height: 22, blocksBullets: false }),
    make(poly.circle(x, y, 38, 14), 'pitwall', { ...o, id: 'tt-hub', part: 'hub', height: 40 }),
    make(poly.transform(poly.rect(-230, -17, 460, 34), { x, y, rot: 0.95 }), 'girder', { ...o, id: 'tt-bridge', part: 'bridge', height: 14, blocksBullets: false }),
  ];
}

export const GEOMETRY = {
  polys: [
    ...[0, 1, 2, 3, 4].flatMap(carriage),
    ...locomotive('loco', LOCO_X + TRAIN.loco / 2 - 4, TRAIN.y),
    ...turntable(),
    make(poly.circle(5250, 400, 118, 22), 'watertower', { id: 'water-tower', group: 'water-tower', shape: 'roundTank', part: 'tank', height: 72 }),
    ...locomotive('stored', 5250, 2125),
    // Level crossing: a barrier arm lowered across the near half of the road, red and white, that bodies stop at but bullets and sight pass.
    make(poly.rect(2850, 2593, 150, 14), 'barrier', { id: 'xing-arm', group: 'crossing', shape: 'barrier', part: 'arm', height: 8, blocksBullets: false, blocksSight: false }),
  ] satisfies MapPoly[],
  doors: [
  {id: 'tk-w', kind: 'double-slide', x: 325, y: 450, w: 150, axis: 'v', material: 'glass', glow: '#ffd9a0'},
  {id: 'tk-arch', kind: 'double-slide', x: 750, y: 875, w: 200, axis: 'h', material: 'glass', glow: '#ffd9a0'},
  {id: 'tk-e', kind: 'slide', x: 1425, y: 500, w: 100, axis: 'v', material: 'metal'},
  {id: 'co-w1', kind: 'double-swing', x: 325, y: 1200, w: 150, axis: 'v', material: 'wood'},
  {id: 'co-w2', kind: 'double-swing', x: 325, y: 1700, w: 150, axis: 'v', material: 'wood'},
  {id: 'co-p2', kind: 'double-slide', x: 1425, y: 950, w: 200, axis: 'v', material: 'glass'},
  {id: 'co-p3', kind: 'double-slide', x: 1425, y: 1450, w: 200, axis: 'v', material: 'glass'},
  {id: 'co-p4', kind: 'double-swing', x: 1425, y: 1900, w: 200, axis: 'v', material: 'wood'},
  {id: 'co-wr', kind: 'double-swing', x: 500, y: 2175, w: 150, axis: 'h', material: 'wood'},
  {id: 'co-bf', kind: 'swing', x: 1050, y: 2175, w: 100, axis: 'h', material: 'wood'},
  {id: 'wr-w', kind: 'swing', x: 325, y: 2450, w: 100, axis: 'v', material: 'wood'},
  {id: 'wr-s', kind: 'swing', x: 600, y: 2825, w: 100, axis: 'h', material: 'wood'},
  {id: 'bf-s', kind: 'double-swing', x: 1050, y: 2825, w: 150, axis: 'h', material: 'wood'},
  {id: 'bf-e', kind: 'swing', x: 1425, y: 2450, w: 100, axis: 'v', material: 'wood'},
  {id: 'p1-gn', kind: 'double-swing', x: 1800, y: 375, w: 150, axis: 'h', material: 'wood'},
  {id: 'p1-gm', kind: 'swing', x: 2900, y: 375, w: 100, axis: 'h', material: 'wood'},
  {id: 'p2-s', kind: 'swing', x: 2350, y: 1075, w: 100, axis: 'h', material: 'wood'},
  {id: 'p2-n', kind: 'swing', x: 2500, y: 925, w: 100, axis: 'h', material: 'wood'},
  {id: 'p3-n', kind: 'swing', x: 2950, y: 1525, w: 100, axis: 'h', material: 'wood'},
  {id: 'p3-s', kind: 'swing', x: 3100, y: 1675, w: 100, axis: 'h', material: 'wood'},
  {id: 'lr-n', kind: 'double-swing', x: 1900, y: 2525, w: 150, axis: 'h', material: 'wood'},
  {id: 'lr-e', kind: 'swing', x: 2175, y: 2600, w: 100, axis: 'v', material: 'wood'},
  {id: 'hut-w', kind: 'swing', x: 2575, y: 2450, w: 100, axis: 'v', material: 'wood'},
  {id: 'sb-s', kind: 'swing', x: 4250, y: 1125, w: 100, axis: 'h', material: 'wood'},
  {id: 'sb-w', kind: 'swing', x: 4125, y: 950, w: 100, axis: 'v', material: 'wood'},
  {id: 'tn-n', kind: 'swing', x: 5700, y: 1175, w: 100, axis: 'h', material: 'wood'},
  {id: 'tn-s', kind: 'swing', x: 5700, y: 1425, w: 100, axis: 'h', material: 'wood'},
  {id: 'go-n', kind: 'swing', x: 3300, y: 1825, w: 100, axis: 'h', material: 'wood'},
  {id: 'go-s', kind: 'swing', x: 3200, y: 2075, w: 100, axis: 'h', material: 'wood'},
  {id: 'go-w', kind: 'double-swing', x: 3125, y: 1900, w: 150, axis: 'v', material: 'wood'},
  {id: 'es-w1', kind: 'double-swing', x: 4825, y: 1800, w: 150, axis: 'v', material: 'wood'},
  {id: 'es-w2', kind: 'double-swing', x: 4825, y: 2050, w: 150, axis: 'v', material: 'wood'},
  {id: 'es-w3', kind: 'double-swing', x: 4825, y: 2300, w: 150, axis: 'v', material: 'wood'},
  {id: 'es-e', kind: 'swing', x: 5725, y: 2100, w: 100, axis: 'v', material: 'wood'},
  {id: 'es-n', kind: 'swing', x: 5150, y: 1725, w: 100, axis: 'h', material: 'wood'},
  {id: 'es-s', kind: 'swing', x: 5200, y: 2575, w: 100, axis: 'h', material: 'wood'},
    // The walk-through carriage: sliding doors that open on a body in reach, so each side of the platform is a way in.
    { id: 'car3-n1', kind: 'slide', x: carriageX(2) + 80, y: TRAIN.y - TRAIN.wid / 2 + TRAIN.wall / 2, w: 100, axis: 'h', material: 'metal', hinge: 'start', glow: '#ffd9a0', thick: TRAIN.wall },
    { id: 'car3-n2', kind: 'slide', x: carriageX(2) + 360, y: TRAIN.y - TRAIN.wid / 2 + TRAIN.wall / 2, w: 100, axis: 'h', material: 'metal', hinge: 'end', glow: '#ffd9a0', thick: TRAIN.wall },
    { id: 'car3-s1', kind: 'slide', x: carriageX(2) + 80, y: TRAIN.y + TRAIN.wid / 2 - TRAIN.wall / 2, w: 100, axis: 'h', material: 'metal', hinge: 'start', glow: '#ffd9a0', thick: TRAIN.wall },
    { id: 'car3-s2', kind: 'slide', x: carriageX(2) + 360, y: TRAIN.y + TRAIN.wid / 2 - TRAIN.wall / 2, w: 100, axis: 'h', material: 'metal', hinge: 'end', glow: '#ffd9a0', thick: TRAIN.wall },
  ] satisfies MapDoor[],
  roofs: [
  { id: 'tickethall', points: poly.rect(300, 200, 1150, 700), material: 'glass' },
  { id: 'concourse', points: poly.rect(300, 850, 1150, 1350), material: 'vault' },
  { id: 'waiting', points: poly.rect(300, 2150, 550, 700), material: 'slate' },
  { id: 'buffet', points: poly.rect(800, 2150, 650, 700), material: 'slate' },
  { id: 'p2room', points: poly.rect(2200, 900, 500, 200), material: 'slate' },
  { id: 'p3room', points: poly.rect(2800, 1500, 500, 200), material: 'slate' },
  { id: 'can1', points: poly.rect(1720, 480, 1730, 90), material: 'iron' },
  { id: 'can2', points: poly.rect(1720, 980, 1730, 90), material: 'iron' },
  { id: 'can3', points: poly.rect(1720, 1480, 1730, 90), material: 'iron' },
  { id: 'can4', points: poly.rect(1720, 1980, 1730, 90), material: 'iron' },
  { id: 'lamproom', points: poly.rect(1800, 2500, 400, 300), material: 'slate' },
  { id: 'hut', points: poly.rect(2550, 2400, 200, 200), material: 'slate' },
  { id: 'signalbox', points: poly.rect(4100, 850, 400, 300), material: 'slate' },
  { id: 'tunnel', points: poly.rect(5600, 1100, 400, 400), material: 'rock' },
  { id: 'goods', points: poly.rect(3100, 1800, 500, 300), material: 'slate' },
  { id: 'engineshed', points: poly.rect(4800, 1700, 950, 900), material: 'iron' },
    { id: 'car3-roof', points: poly.rect(carriageX(2), TRAIN.y - TRAIN.wid / 2, TRAIN.len, TRAIN.wid), material: 'carriage' },
  ] satisfies MapRoof[],
};

export const RAILYARD = withGeometry(gridMap('Rail Yard', WEST, 'railyard'), GEOMETRY);

